import VueI18nPhrase from './src/vue-i18n-phrase';

export * from './src/vue-i18n-phrase-formatter';
export * from './src/phrase-config.type';
export default VueI18nPhrase;
